import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../baseQuery';

export interface UiPreferences {
  shippingGuideBannerDismissed: boolean;
  hasSeenTradeConfirmModal: boolean;
  hasSeenFirstTradeCelebration: boolean;
  dismissedBonusTaskKeys?: string[];
  /** Homepage post-50 want-list banner dismissed (ISO timestamp); null clears it. Read back via the checklist. */
  homeWantBannerDismissedAt?: string | null;
}

export const uiPreferencesApi = createApi({
  reducerPath: 'uiPreferencesApi',
  baseQuery: baseQuery,
  tagTypes: ['UiPreferences'],
  endpoints: (builder) => ({
    getUiPreferences: builder.query<UiPreferences, void>({
      query: () => ({
        url: '/settings/ui-preferences',
        method: 'GET',
        requiresAuth: true,
      }),
      providesTags: ['UiPreferences'],
    }),

    updateUiPreferences: builder.mutation<
      { success: boolean; settings: UiPreferences },
      Partial<UiPreferences>
    >({
      query: (body) => ({
        url: '/settings/ui-preferences',
        method: 'PUT',
        body,
        requiresAuth: true,
      }),
      invalidatesTags: ['UiPreferences'],
    }),
  }),
});

export const {
  useGetUiPreferencesQuery,
  useUpdateUiPreferencesMutation,
} = uiPreferencesApi;
